// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Breadcrumbs from "@insite/mobius/Breadcrumbs";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { SectionContainer, SectionTitle } from "@tps/App/Widgets/DesignSystem/DesignSystem.helpers";
import { dummyLinks } from "@tps/App/Widgets/DesignSystem/DummyData/DummyData";
import React, { FC } from "react";
import { css } from "styled-components";

interface BreadcrumbsTabStyles {
    gridItem?: GridItemProps;
    breadcrumbsWrapper?: InjectableCss;
}

const breadcrumbsTabStyles: BreadcrumbsTabStyles = {
    gridItem: {
        width: 12,
        css: css`
            flex-wrap: wrap;
            padding-bottom: 40px;
        `,
    },
    breadcrumbsWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-top: 20px;
            flex-wrap: wrap;
        `,
    },
};

const styles = breadcrumbsTabStyles;
const BreadcrumbsTab: FC = props => {
    return (
        <SectionContainer>
            <GridItem {...styles.gridItem}>
                <SectionTitle>Short Breadcrumbs</SectionTitle>
                <StyledWrapper {...styles.breadcrumbsWrapper}>
                    <Breadcrumbs links={dummyLinks.slice(0, 4)} />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.gridItem}>
                <SectionTitle>Long Breadcrumbs</SectionTitle>
                <StyledWrapper {...styles.breadcrumbsWrapper}>
                    <Breadcrumbs links={dummyLinks} />
                </StyledWrapper>
            </GridItem>
        </SectionContainer>
    );
};

export default BreadcrumbsTab;
